import { render, staticRenderFns } from "./fbpClaims.vue?vue&type=template&id=e6ca3e54&scoped=true"
import script from "./fbpClaims.vue?vue&type=script&lang=js"
export * from "./fbpClaims.vue?vue&type=script&lang=js"
import style0 from "./fbpClaims.vue?vue&type=style&index=0&id=e6ca3e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ca3e54",
  null
  
)

export default component.exports